// Legacy code, credits to Juan Carlos Casado.
// IpV6
//
var IpV6 = (function() {
  let CONST = {
    ST_INIT: 'INI',
    ST_PRE_NUM: 'pN',
    ST_PRE_COL: 'pCO',
    ST_HEAD_DCOL: 'HDC',
    ST_EMB_DCOL: 'EDC',
    ST_POST_NUM: 'PN',
    ST_POST_COL: 'PCO',
    ST_SLASH: 'SL',
    ST_CIDR: 'CIDR',
    ST_ERROR: 'ERR',
    ST_ADDR_OK: 'ADDR_OK',
    ST_CIDR_OK: 'CIDR_OK',
  };

  function Scanner() {
    this.str;
    this.idx;
    this.length;
    this.c;
  };
  Scanner.prototype = {
    init: function(str) {
      this.str = str;
      this.idx = 0;
      this.length = str.length;

      this.COLON = ':';
      this.SLASH = '/';
      this.HEX_CHAR_L = '0123456789abcdef';
      this.HEX_CHAR_U = '0123456789ABCDEF';
      this.TK_SLASH = 'SL';
      this.TK_SINGLE_COLON = 'SC';
      this.TK_DOUBLE_COLON = 'DC';
      this.TK_HEX_NUMBER = 'N';
      this.TK_EOF = 'EOF';
      this.TK_ERROR = 'ERR';

      this.c = this.getChar();
    },
    getChar: function() {
      if (this.idx ==  this.length) return null; // EOF
      else return this.str.charAt(this.idx++);
    },
    isHexChar: function(c) {
      return (this.HEX_CHAR_L.indexOf(c) > -1 || this.HEX_CHAR_U.indexOf(c) > -1);
    },
    token: function(type, value) {
      return {type: type, value: value};
    },
    getToken: function() {
      //console.log('idx = %d, len = %d', this.idx, this.length);
      if (this.c ===  null) {
        return this.token(this.TK_EOF, null);
      } else if (this.c == this.SLASH) {
        this.c = this.getChar();
        return this.token(this.TK_SLASH, null);
      } else if (this.c == this.COLON) {
        this.c = this.getChar();
        if (this.c == this.COLON) {
          this.c = this.getChar();
          return this.token(this.TK_DOUBLE_COLON, null);
        } else {
          return this.token(this.TK_SINGLE_COLON, null);
        }
      } else if (this.isHexChar(this.c)) {
        var number = this.c;
        while (this.isHexChar(this.c = this.getChar())) {
          number += this.c;
        }
        if (number.length > 4) {
          return this.token(this.TK_ERROR, 'invalid number '+number);
        } else {
          return this.token(this.TK_HEX_NUMBER, number);
        }
      } else {
          return this.token(this.TK_ERROR, 'unexpected char '+this.c);
      }
    },
  };

  var contractNumber = function(value) {
    var i = 0, len = value.length - 1;
    while (value.charAt(i) == '0' && i < len) i++;
    return value.substr(i);
  };
  var expandNumber = function(value) {
    var exp = value;
    for (var i = 4 - value.length; i; i--) {
      exp = '0' + exp;
    }
    return exp;
  };
  var parseResult = function(status, errorMsg, items, numCnt, prefix) {
    return {
      status: status,
      errorMsg: errorMsg,
      items: items,
      numCnt: numCnt,
      prefix: prefix,
    };
  };
  var expanded = function(itCnt, items) {
    var exp = [];
    for (var j = 0, len = items.length; j < len; j++) {
      if (items[j] == '*') {
        for (var k = 8 - itCnt; k > 0; k--) exp.push('0');
      } else {
        exp.push(items[j]);
      }
    }
    return exp;
  };
  var full = function(itCnt, items) {
    var exp = [];
    for (var j = 0, len = items.length; j < len; j++) {
      if (items[j] == '*') {
        for (var k = 8 - itCnt; k > 0; k--) exp.push('0000');
      } else {
        exp.push(expandNumber(items[j]));
      }
    }
    return exp;
  };
  var canonical = function(expandedItems) {
    var zeroCnt = [0,0,0,0,0,0,0,0],
      zeroIdx = null,
      can = [],
      canStr = '';
    // Count successive 0 in zeroCnt
    for (var j = 0; j < 8; j++) {
      if (expandedItems[j] == 0) {
        if (zeroIdx === null) { zeroIdx = j; }
        zeroCnt[zeroIdx] += 1;
      } else {
        zeroIdx = null
      }
    }
    //console.log('ZEROES: %s', JSON.stringify(zeroCnt));
    // Get max 0 sequence index in zeroIdx
    zeroIdx = null;
    for (var j = 0; j < 8; j++) {
      if (zeroCnt[j] > 1) {
        if (zeroIdx === null) zeroIdx = j;
        else if (zeroCnt[j] > zeroCnt[zeroIdx]) zeroIdx = j;
      }
    }
    //console.log('MAX-ZEROES: %d', zeroIdx);
    // Contract max 0 sequence using '::'
    for (var j = 0; j < 8; j++) {
      if (j == zeroIdx) {
        can.push('*');
        while (--zeroCnt[zeroIdx]) j++;
      } else {
        can.push(expandedItems[j]);
      }
    }
    //console.log('CANONICAL: %s', can);
    // Get string from items
    for (var j = 0, len = can.length; j < len; j++) {
      if (j == 0) canStr += (can[j] == '*' ? '::' : can[j]+':');
      else if (j == len-1) canStr += (can[j] == '*' ? ':' : can[j]);
      else canStr += (can[j] == '*' ? ':' : can[j]+':');
    }
    return canStr;
  };

  var scanner = new Scanner();

  var _parse = function(s) {
    var st = CONST.ST_INIT,
      tk = null,
      numCnt = 0,
      prefix = null,
      items = [];

    scanner.init(s);
    do {
      tk = scanner.getToken();
      //console.log('ST: %s, TK: %s', st, JSON.stringify(tk));
      switch (st) {
        case CONST.ST_INIT:
          if (tk.type == 'N') {
            numCnt++;
            items.push(contractNumber(tk.value))
            st = CONST.ST_PRE_NUM;
          } else if (tk.type == 'DC') {
            items.push('*')
            st = CONST.ST_HEAD_DCOL;
          } else st = CONST.ST_ERROR;
          break;
        case CONST.ST_PRE_NUM:
          if (tk.type == 'SC') {
            st = CONST.ST_PRE_COL;
          } else if (tk.type == 'DC') {
            items.push('*');
            st = CONST.ST_EMB_DCOL;
          } else if (tk.type == 'EOF') {
            if (numCnt == 8) st = CONST.ST_ADDR_OK;
            else st = CONST.ST_ERROR; // Incomplete addr
          } else if (tk.type == 'SL') {
            if (numCnt == 8) st = CONST.ST_SLASH;
          } else st = CONST.ST_ERROR;
          break;
        case CONST.ST_PRE_COL:
          if (tk.type == 'N') {
            numCnt++;
            items.push(contractNumber(tk.value));
            st = CONST.ST_PRE_NUM;
          } else st = CONST.ST_ERROR;
          break;
        case CONST.ST_HEAD_DCOL:
          if (tk.type == 'N') {
            numCnt++;
            items.push(contractNumber(tk.value));
            st = CONST.ST_POST_NUM;
          } else if (tk.type == 'EOF') st = CONST.ST_ADDR_OK; // '::'
          else if (tk.type == 'SL') st = CONST.ST_SLASH;
          else st = CONST.ST_ERROR;
          break;
        case CONST.ST_EMB_DCOL:
          if (tk.type == 'N') {
            numCnt++;
            items.push(contractNumber(tk.value));
            st = CONST.ST_POST_NUM;
          } else if (tk.type == 'EOF') st = CONST.ST_ADDR_OK; // '...::'
          else if (tk.type == 'SL') st = CONST.ST_SLASH;
          else st = CONST.ST_ERROR;
          break;
        case CONST.ST_POST_NUM:
          if (tk.type == 'SC') {
            st = CONST.ST_POST_COL;
          } else if (tk.type == 'EOF') st = CONST.ST_ADDR_OK; // '::...'
          else if (tk.type == 'SL') st = CONST.ST_SLASH;
          else st = CONST.ST_ERROR;
          break;
        case CONST.ST_POST_COL:
          if (tk.type == 'N') {
            numCnt++;
            items.push(contractNumber(tk.value));
            st = CONST.ST_POST_NUM;
          } else st = CONST.ST_ERROR;
          break;
        case CONST.ST_SLASH:
          if (tk.type == 'N') {
            prefix = tk.value;
            if (Number(prefix) <= 128) st = CONST.ST_CIDR;
            else st = CONST.ST_ERROR;
          } else st = CONST.ST_ERROR;
          break;
        case CONST.ST_CIDR:
          if (tk.type == 'EOF') st = CONST.ST_CIDR_OK; // CIDR
          else st = CONST.ST_ERROR;
          break;
        default:
          console.log('SCANNER: unknown status <%s>', st);
          CONST.ST_ERROR;
          break;
      }
    } while (tk.type != 'EOF' && tk.type != 'ERR');
    // Stop condition may be based on status too
    //console.log('END ST: %s, TK: %s, N: %d', st, JSON.stringify(tk), numCnt);
    //console.log('  ADR: %s', s);
    //console.log('  IDX: %s', items);
    //console.log('  EXP: %s', expanded(numCnt, items));
    //console.log('  FUL: %s', full(numCnt, items));
    //console.log('  CAN: %s', canonical(expanded(numCnt, items)));

    return parseResult (st, null, items, numCnt, prefix);
  };

  var _public = {
    isValid: function(s) {
      return (_parse(s).status == CONST.ST_ADDR_OK);
    },
    isValidCidr: function(s) {
      return (_parse(s).status == CONST.ST_CIDR_OK);
    },
    isValidCidrOrAddr: function(s) {
      var ipv6 = _parse(s);
      return (ipv6.status == CONST.ST_CIDR_OK ||
        ipv6.status == CONST.ST_ADDR_OK);
    },
    parse: function(s) {
      return _parse(s);
    },
    normalizeCidr: function(s) {
      if (s.indexOf('/') < 0) return s+'/128';
    },
    toCidr: function(s) {
    },
    canonical: function(s) {
      var ipv6 = _parse(s);
      return canonical(expanded(ipv6.numCnt, ipv6.items));
    },
    expanded: function(s) {
      var ipv6 = _parse(s);
      return expanded(ipv6.numCnt, ipv6.items);
    },
    fullExpanded: function(s) {
      var ipv6 = _parse(s);
      return full(ipv6.numCnt, ipv6.items);
    },
  };

  return _public;
})();


export default IpV6;
